import { openDB } from "idb";
import { store } from "../store";

export const dbPromise = openDB("rrweb-replays", 1, {
  upgrade(db) {
    db.createObjectStore("chunks", {
      keyPath: "id",
      autoIncrement: true
    });
  }
});

export async function saveChunk(chunk) {
  let state = store.getState();
  let loginState = state.loginreducer;

  const db = await dbPromise;
  await db.add("chunks", {
    user: loginState.Login,
    data: chunk,
    createdAt: Date.now()
  });
}

export async function getChunks() {
  const db = await dbPromise;
  return await db.getAll("chunks");
}

export async function getEventsBatch(batchSize) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("rrweb-replays");

    request.onsuccess = (event) => {
      const db = event.target.result;

      const tx = db.transaction("chunks", "readonly");
      const store = tx.objectStore("chunks");

      const getRequest = store.getAll(null, batchSize);

      getRequest.onsuccess = () => resolve(getRequest.result);
      getRequest.onerror = reject;
    };
  });
}

export async function clearChunks() {
  const db = await dbPromise;
  const tx = db.transaction("chunks", "readwrite");
  await tx.objectStore("chunks").clear();
  await tx.done;
}

export async function clearEvents(ids) {
  const request = indexedDB.open("rrweb-replays");

  request.onsuccess = (event) => {
    const db = event.target.result;

    const tx = db.transaction("chunks", "readwrite");
    const store = tx.objectStore("chunks");

    ids.forEach(id => store.delete(id));
  };
}

// export async function deleteOldest(limit = 100) {
//   const request = indexedDB.open("rrweb-replays");

//   request.onsuccess = (event) => {
//     const db = event.target.result;

//     const tx = db.transaction("chunks", "readwrite");
//     const store = tx.objectStore("chunks");

//     const cursorRequest = store.openCursor(null, 'next');

//     cursorRequest.onsuccess = function (event) {
//       const cursor = event.target.result;

//       if (cursor && count < limit) {
//         cursor.delete();
//         count++;
//         cursor.continue();
//       } else {
//         resolve(count);
//       }
//     };


//   };
// }

export async function deleteOldest() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('rrweb-replays');

    request.onsuccess = function (event) {
      const db = event.target.result;
      const tx = db.transaction('chunks', 'readwrite');
      const store = tx.objectStore('chunks');

      const cursorRequest = store.openCursor();

      let deletedCount = 0;
      const DELETE_BATCH = 200;

      cursorRequest.onsuccess = function (e) {
        const cursor = e.target.result;

        if (!cursor || deletedCount >= DELETE_BATCH) {
          resolve();
          return;
        }

        cursor.delete();
        deletedCount++;

        cursor.continue();
      };

      cursorRequest.onerror = reject;
    };

    request.onerror = reject;
  });
}